import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import arrow1 from "../../assets/images/icon/arrow-1.svg";
// import graph from "../../assets/images/icon/graph.png";
import FunnelSeries from "./FunnelSeries";
import PieChartDetails from "./PieChart";
import ReactApexChart from "react-apexcharts";
import AcceptanceChart from "./AcceptanceChart";
import { FetchDashboardData } from "helpers/backend_helper";
import { toast } from "react-toastify";
import { decryptDataFromArray } from "helpers/EncDec";
import { useTranslation } from "react-i18next";

const HiringCharts = props => {
  const { t } = useTranslation();
  // const [data, setData] = useState({});
  // let datafromDashboard = props?.data || {};
  let pieChartData = props?.pieChartData || [];
  let acceptanceDetails = props?.acceptanceDetails || {};
  let type = props?.type || "";
  let startDate = props?.startDate || "";
  let endDate = props?.endDate || "";
  let jobTitles = props?.jobTitles || [];

  let datafromDashboard = props?.data || {};
  const [data, setData] = useState(datafromDashboard);

  let myData = [
    {
      stage: "Total Applied",
      applicants: data?.totalApplicants || 0,
      percentage: 100,
    },
    // {
    //     stage: "Pending",
    //     applicants: data?.pendingUsers || 0
    // },
    {
      stage: "Link Sent",
      applicants: data?.screeningUsers || 0,
      percentage:
        ((data?.screeningUsers || 0) / data?.totalApplicants || 0) * 100,
    },
    {
      stage: "Called for Interview",
      applicants: data?.scheduledUsers || 0,
      percentage:
        ((data?.scheduledUsers || 0) / data?.totalApplicants || 0) * 100,
    },
    {
      stage: "Selected",
      applicants: data?.selectedUsers || 0,
      percentage:
        ((data?.selectedUsers || 0) / data?.totalApplicants || 0) * 100,
    },
    {
      stage: "Onboarded",
      applicants: data?.onboardedUsers || 0,
      percentage:
        ((data?.onboardedUsers || 0) / data?.totalApplicants || 0) * 100,
    },
    // {
    //     stage: "On Hold",
    //     applicants: data?.onholdUsers || 0
    // },
    // {
    //     stage: "Rejected",
    //     applicants: data?.rejectedUsers || 0
    // },
  ];

  const [selectedJobTitle, setSelectedJobTitle] = useState("");

  const handleJobTitleChange = e => {
    const jobId = e.target.value;
    setSelectedJobTitle(jobId);
    getDashboardData(jobId);
  };

  const getDashboardData = async jobId => {
    const payload = `?type=${type}&startDate=${startDate}&endDate${endDate}=&jobId=${jobId}`;
    await FetchDashboardData(payload)
      .then(res => {
        let responseData = decryptDataFromArray(res);

        if (responseData?.status) {
          let dataFromApi = responseData?.data?.funnelData;

          setData(dataFromApi);
        }
      })
      .catch(err => {
        toast.error(err?.response?.data?.message || "Something Went Wrong.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  let totalValue = pieChartData?.reduce(
    (sum, item) => sum + (item.value || 0),
    0
  );
  let legendsData = pieChartData?.map(item => {
    let value = item.value || 0;
    let percentage = totalValue ? (value / totalValue) * 100 : 0;
    let formattedValue = Number.isInteger(percentage)
      ? `${percentage.toFixed(0)}%`
      : `${percentage.toFixed(2)}%`;

    return {
      name: item.title.trim(), // Remove unnecessary spaces
      value: formattedValue.trim(), // Remove unnecessary spaces
    };
  });

  // return (
  //   <div className="vacancy-tabel hiringsource pt-0">
  //     <div className="eligible-content mt-1">
  //       <h3 className="d-flex align-items-center gap-2 heading-one">
  //         {/* Hiring Source Pie Chart */}
  //         {t(`Dashboard.Source of Hiring`)}
  //       </h3>
  //       <h6 className="d-flex gap-3">
  //         <Link
  //           to="/all-applications"
  //           className="gap-2 d-flex align-items-center view_link"
  //         >
  //           {t(`Dashboard.View All`)} <img src={arrow1} alt="Arrow Icon" />
  //         </Link>
  //       </h6>
  //     </div>

  //     <div className="cards-section mb-3">
  //       <PieChartDetails data={pieChartData || []} t={t} />
  //       <div className="cards-para">
  //         {legendsData?.length > 0 &&
  //           legendsData?.map(el => {
  //             return (
  //               <p>
  //                 {el?.name} : {el?.value}
  //               </p>
  //             );
  //           })}
  //       </div>
  //     </div>
  //   </div>
  // );
};

export default HiringCharts;
